import styled from 'styled-components';

const CloseButton = styled.div`
  position: absolute;
  right: 1vw;
  top: 1vw;
  transition: transform 0.15s ease-in-out;

  &:hover {
    transform: rotate(90deg);
  }
`;

export default CloseButton;
